/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import sanitizeHtml from "sanitize-html";

export function sanitizedHtml(content) {
  const htmlSanitizeOptions = {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['li', 'ul', 'b', 'a']),
    allowedAttributes: {
      a: ['href', 'target', 'class']
    }
  };

  const replacedMessage = content.replaceAll("\\n", "<br/>").replaceAll("\\", "");
  return sanitizeHtml(replacedMessage, htmlSanitizeOptions);
}

export function isNullOrEmpty(parameter){
  return parameter === null  || parameter === undefined || parameter.length === 0;
}

export function returnLandingPage(){
  window.open("/", "_self");
}
